import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * A component that scrolls the window to the top on every route change.
 * This ensures that navigating to a new page starts at the top, which is
 * the expected behavior for users.
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Use a timeout to ensure the scroll happens after the new page has started rendering.
    // The 'instant' behavior ensures there's no smooth scrolling animation.
    const timer = setTimeout(() => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'instant'
      });
    }, 0);

    return () => clearTimeout(timer);
  }, [pathname]);

  return null; // This component does not render anything
};

export default ScrollToTop;
